import classNames from "classnames";
import CollegeLogo from "rivals/components/shared/CollegeLogo";
import RivalsLink from "rivals/components/shared/Link";
import { MEDIA_BREAKPOINTS } from "rivals/media";
import { NO_PROFILE_PICTURE } from "rivals/shared/constants";
import styles from "./index.module.scss";
import strings from "./strings";
import { getTransferDetails } from "./transferDetails";
import { OwnProps } from "./types";

const { empty, philter } = strings;

const TransferCard = ({ transfer }: OwnProps): JSX.Element => {
  const {
    athleteUrl,
    collegePlayerName,
    collegePlayerPosition,
    collegePlayerProfileImage,
    originCollegeColor,
    originCollegeLogo,
    originCollegeName
  } = transfer;

  const {
    backgroundClass,
    exitCollegeColor,
    exitCollegeLogo,
    exitCollegeName,
    headerText
  } = getTransferDetails(transfer);

  return (
    <RivalsLink
      className={styles.cardWrapper}
      data={`${philter}-transfer-card`}
      href={athleteUrl}
    >
      <div className={classNames(styles.cardHeader, styles[backgroundClass])}>
        {headerText}
      </div>
      <div className={styles.cardBody}>
        <img
          alt="profile image"
          className={styles.profileImage}
          src={collegePlayerProfileImage || NO_PROFILE_PICTURE}
        />
        <div className={styles.transferDetails}>
          <div>{collegePlayerName}</div>
          <div>{collegePlayerPosition || empty}</div>
          <div>
            <CollegeLogo
              collegeLogo={originCollegeLogo}
              collegeName={originCollegeName}
              collegeSiteColor={originCollegeColor}
              logoSize={48}
              mobileBreakpoint={MEDIA_BREAKPOINTS.SM}
              mobileSize={30}
            />
            <span className={styles.chevrons} />
            <CollegeLogo
              collegeLogo={exitCollegeLogo}
              collegeName={exitCollegeName}
              collegeSiteColor={exitCollegeColor}
              logoSize={48}
              mobileBreakpoint={MEDIA_BREAKPOINTS.SM}
              mobileSize={30}
            />
          </div>
        </div>
      </div>
    </RivalsLink>
  );
};

export default TransferCard;
